import React, { useCallback, useContext, useState } from 'react';

import PartiesInvolvedTable from '@totem/components/ticketing/details/partiesInvolved/partiesInvolvedTable';
import {
  PartyInvolved,
  TicketQueryResult,
} from '@totem/components/ticketing/ticketing';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { TICKET_ENDPOINT } from '@totem/utilities/endpoints';

import '../../ticketing.css';
type Props = {
  ticket: TicketQueryResult;
  onTicketUpdated: (ticketData: TicketQueryResult) => void;
};
const PartiesInvolved = ({ ticket, onTicketUpdated }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [isSending, setIsSending] = useState(false);
  const sendEndPartyInvolvement = useCallback(
    async (partyInvolvedId: string) => {
      if (isSending) {
        return;
      }
      fetch(
        `${TICKET_ENDPOINT}/${ticket.ticket.id}/partyInvolved/${partyInvolvedId}`,
        {
          method: 'DELETE',
          headers: new Headers({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getApiToken()}`,
          }),
        },
      )
        .then((res) => res.json())
        .then((result) => {
          onTicketUpdated(result);
        })
        .then(() => {
          setIsSending(false);
        });

      setIsSending(true);
    },
    [isSending],
  );
  const handleEndPartyInvolvement = (partyInvolvedId: PartyInvolved) => {
    sendEndPartyInvolvement(partyInvolvedId.id);
  };
  return (
    ticket !== null &&
    ticket.ticket !== null &&
    ticket.ticket.partiesInvolved !== null && (
      <PartiesInvolvedTable
        ticket={ticket}
        onEndPartyInvolvement={handleEndPartyInvolvement}
      />
    )
  );
};
export default PartiesInvolved;
